// Types of organizations that can be targeted by a messaging list rule.
// Used by both the initial-suggestions and search queries so the two lists
// stay consistent — otherwise an org that shows up in suggestions can vanish
// when the user searches for it.
export function getAllowedOrganizationTypes(
  currentOrganizationType: string,
): string[] {
  const allowedTypes = ["school", "district", "classroom"];
  if (!allowedTypes.includes(currentOrganizationType)) {
    // make sure that the current org's type is included so can add current page to rules
    allowedTypes.push(currentOrganizationType);
    if (!allowedTypes.includes("section")) {
      // if we're here it means this is a subpage, so make sure sections are included so sub-subpages are allowed
      allowedTypes.push("section");
    }
  }
  return allowedTypes;
}
